import { render, staticRenderFns } from "./ConsentBox.vue?vue&type=template&id=ead812b0"
import script from "./ConsentBox.vue?vue&type=script&lang=js"
export * from "./ConsentBox.vue?vue&type=script&lang=js"
import style0 from "./ConsentBox.vue?vue&type=style&index=0&id=ead812b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports